import { generateBreadcrumbs } from '@bv/utils/route/breadcrumbs/generate-breadcrumbs';

import { Module, useWorkspaceBillingQuota } from '@/composables/billing/useWorkspaceBillingQuota';
import { formModeEnum } from '@/types/general';

const campaignsBreadcrumbs = generateBreadcrumbs({
  label: 'global.sidebar.all-broadcasts_trans',
  route: { name: 'campaigns' },
});

const broadcasts_routes = [
  {
    path: '/campaigns',
    alias: '/broadcasts',
    name: 'campaigns',
    redirect: { name: 'all-campaigns' },
    component: () => import('@/views/System/Broadcasts/BroadcastsView.vue'),
    meta: {
      header: {
        title: 'GLOBAL.NAVS.broadcasts_trans',
        icon: 'bvi-announcement',
      },
    },
    children: [
      {
        path: '',
        name: 'all-campaigns',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-list/BroadcastsList.vue'),
        meta: {
          permissions: 'read-broadcasts',
          breadcrumbs: campaignsBreadcrumbs(),
        },
      },
      {
        path: 'add',
        name: 'campaign-add',
        async beforeEnter() {
          const quota = useWorkspaceBillingQuota(Module.BROADCAST);
          if (!quota.fetchAttempted.value) {
            await quota.fetchQuota();
          }
        },
        component: () => import('@/views/System/Broadcasts/partials/broadcast-form/BroadcastForm.vue'),
        meta: {
          formType: formModeEnum.ADD,
          permissions: 'write-broadcasts',
          breadcrumbs: campaignsBreadcrumbs(),
        },
      },
      {
        path: ':id/edit',
        name: 'campaign-edit',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-form/BroadcastForm.vue'),
        meta: {
          formType: formModeEnum.EDIT,
          permissions: 'update-broadcasts',
          breadcrumbs: campaignsBreadcrumbs(),
        },
      },
      {
        path: ':id',
        name: 'campaign-show',
        component: () => import('@/views/System/Broadcasts/partials/broadcast-details/BroadcastDetails.vue'),
        meta: {
          permissions: 'read-broadcasts',
          breadcrumbs: campaignsBreadcrumbs(),
        },
      },
    ],
  },
];

export default broadcasts_routes;
